export default __webpack_public_path__ + "images/models/25dbd3a2d247bfb32a696a1b86abcc53.glb";